export default __webpack_public_path__ + "static/media/KOD0066-min.063fba11.webp";